// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"757":"068dbb6b76211111","2165":"0becbacc772e6bc9","7938":"cc206c202c1b8141","8259":"8b6f22b685233502","8552":"8487ce50197aa198"}[chunkId] + ".js";
};